/* eslint-disable import/first, import/newline-after-import */

import 'components/util/logos/logos';
import 'components/global/notifications-menu/notifications-menu';

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import { featureEnabled, splitTestEnabled } from 'lib/helpers'; // eslint-disable-line import/order

import SiteHeaderController from 'components/global/site-header/site-header-controller';
EezyStimulusApplication.register('site-header', SiteHeaderController);

/* start: split-test marketing_notifications_v1 */
if (featureEnabled('marketing-notifications-v1') || splitTestEnabled('marketing-notifications-v1')) {
  import(
    /* webpackChunkName: "notifications-menu-controller" */
    /* webpackPreload: true */
    'components/global/notifications-menu/notifications-menu-controller'
  ).then((controller) => {
    EezyStimulusApplication.register('notifications-menu', controller.default);
  });
}
/* end: split-test marketing_notifications_v1 */

import(
  /* webpackChunkName: "search-explore-nav-controller" */
  /* webpackPreload: true */
  'components/global/search-explore-nav/search-explore-nav-controller'
).then((controller) => {
  EezyStimulusApplication.register('search-explore-nav', controller.default);
});
